"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_jss_1 = __importDefault(require("react-jss"));
const filesize_1 = __importDefault(require("filesize"));
const fileField_style_1 = __importDefault(require("./fileField.style"));
const FileField = ({ classes, formData, schema: { title } }) => {
    if (!formData || !formData.length)
        return null;
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.title }, { children: title }), void 0),
            jsx_runtime_1.jsx("ul", Object.assign({ className: classes.root }, { children: formData.map(file => (jsx_runtime_1.jsxs("li", Object.assign({ className: classes.file }, { children: [file.name, " ", jsx_runtime_1.jsx("small", { children: filesize_1.default(file.size) }, void 0)] }), file.name))) }), void 0)] }, void 0));
};
exports.FileField = FileField;
exports.default = react_jss_1.default(fileField_style_1.default)(exports.FileField);
//# sourceMappingURL=index.js.map